export const CONSENT_CODES = ['65001', '65004', '650052', '70011', '90094'];
